<template>
  <lazy-div :load="doInit">
    <v-card>
      <!-- <v-card-title>
        <div class="headline">GL Account No. Details</div>
      </v-card-title> -->
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="newGLAcctNo">mdi-plus</v-icon>
        <v-icon v-else>mdi-pencil</v-icon>
        <v-toolbar-title v-if="newGLAcctNo">Create New GL Account No.</v-toolbar-title>
        <v-toolbar-title v-else>Edit GL Account No.</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                :label="labels.branch"
                v-model="glacctNoForm.branch"
                :error-messages="errors.collect('branch')"
                data-vv-name="branch"
                :data-vv-as="labels.branch"
                v-validate="'required|max:4'"
                :hint="glacctNoForm.brnDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('branch')"
                @change="doCheck('branch')"
                :disabled="!newGLAcctNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="labels.glacctNo"
                v-model="glacctNoForm.glacctNo"
                :error-messages="errors.collect('glacctNo')"
                data-vv-name="glacctNo"
                :data-vv-as="labels.glacctNo"
                v-validate="'required|max:16'"
                :disabled="!newGLAcctNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                :label="labels.fund"
                v-model="glacctNoForm.fund"
                :error-messages="errors.collect('fund')"
                data-vv-name="fund"
                :data-vv-as="labels.fund"
                v-validate="'max:4'"
                :hint="glacctNoForm.fundDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('fund')"
                @change="doCheck('fund')"
                :disabled="!newGLAcctNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="labels.acctNoSfx"
                v-model="glacctNoForm.acctNoSfx"
                :error-messages="errors.collect('acctNoSfx')"
                data-vv-name="acctNoSfx"
                :data-vv-as="labels.acctNoSfx"
                v-validate="'max:4'"
                :hint="glacctNoForm.acctNoSfxDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('acctNoSfx')"
                @change="doCheck('acctNoSfx')"
                :disabled="!newGLAcctNo"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                :label="labels.description"
                v-model="glacctNoForm.description"
                :error-messages="errors.collect('description')"
                data-vv-name="description"
                :data-vv-as="labels.description"
                v-validate="'required|entry|max:40'"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-autocomplete
                v-model="glacctNoForm.acctType"
                :items="acctTypeList"
                :label="labels.acctType"
                item-text="label"
                item-value="value"
                data-vv-name="acctType"
                :data-vv-as="labels.acctType"
                :error-messages="errors.collect('acctType')"
                v-validate="'required'"
                :disabled="!newGLAcctNo"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                v-model="glacctNoForm.postType"
                :items="postTypeList"
                :label="labels.postType"
                item-text="label"
                item-value="value"
                data-vv-name="postType"
                :data-vv-as="labels.postType"
                :error-messages="errors.collect('postType')"
                v-validate="'required'"
                :disabled="!newGLAcctNo"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                :label="labels.curr"
                v-model="glacctNoForm.curr"
                :error-messages="errors.collect('curr')"
                data-vv-name="curr"
                :data-vv-as="labels.curr"
                v-validate="'required|max:4'"
                :hint="glacctNoForm.currDesc"
                persistent-hint
                append-icon="mdi-magnify"
                @click:append="doHelplist('curr')"
                @change="doCheck('curr')"
                :disabled="!newGLAcctNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
                :label="labels.revalue"
                v-model="glacctNoForm.revalue"
                :error-messages="errors.collect('revalue')"
                data-vv-name="revalue"
                :data-vv-as="labels.revalue"
                :disabled="!revalueAE"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <template v-if="glacctNoForm.revalue">
            <div class="body-2">
              {{ labels.revalueAcctNo }} &nbsp;
              <v-icon @click="doHelplist('revalueAcct')">mdi-magnify</v-icon>
            </div>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  label="Account No."
                  v-model="glacctNoForm.revalueAcctNo"
                  :error-messages="errors.collect('revalueAcctNo')"
                  data-vv-name="revalueAcctNo"
                  :data-vv-as="labels.revalueAcctNo"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Fund"
                  v-model="glacctNoForm.revalueFund"
                  :error-messages="errors.collect('revalueFund')"
                  data-vv-name="revalueFund"
                  :data-vv-as="labels.revalueFund"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  label="Account No. Suffix"
                  v-model="glacctNoForm.revalueAcctNoSfx"
                  :error-messages="errors.collect('revalueAcctNoSfx')"
                  data-vv-name="revalueAcctNoSfx"
                  :data-vv-as="labels.revalueAcctNoSfx"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </template>
          <V-layout wrap>
            <v-flex xs6>
              <v-checkbox
                :label="labels.permGst"
                v-model="glacctNoForm.permGst"
                :error-messages="errors.collect('permGst')"
                data-vv-name="permGst"
                :data-vv-as="labels.permGst"
              ></v-checkbox>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
                :label="labels.permDebtCashExp"
                v-model="glacctNoForm.permDebtCashExp"
                :error-messages="errors.collect('permDebtCashExp')"
                data-vv-name="permDebtCashExp"
                :data-vv-as="labels.permDebtCashExp"
              ></v-checkbox>
            </v-flex>
          </V-layout>
          <div class="body-2">
            {{ labels.parentAcct }} &nbsp; <v-icon v-if="newGLAcctNo" @click="doHelplist('parentAcct')">mdi-magnify</v-icon> &nbsp;
            <v-icon v-if="newGLAcctNo" @click="doClearParentAcct">mdi-close</v-icon>
          </div>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                label="Account No."
                v-model="glacctNoForm.parentAcctNo"
                :error-messages="errors.collect('parentAcctNo')"
                data-vv-name="parentAcctNo"
                :data-vv-as="labels.parentAcctNo"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="Fund"
                v-model="glacctNoForm.parentFund"
                :error-messages="errors.collect('parentFund')"
                data-vv-name="parentFund"
                :data-vv-as="labels.parentFund"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                label="Account No. Suffix"
                v-model="glacctNoForm.parentAcctNoSfx"
                :error-messages="errors.collect('parentAcctNoSfx')"
                data-vv-name="parentAcctNoSfx"
                :data-vv-as="labels.parentAcctNoSfx"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6 v-if="!newGLAcctNo">
              <v-text-field
                :label="labels.yrClosed"
                v-model.number="glacctNoForm.yrClosed"
                :error-messages="errors.collect('yrClosed')"
                data-vv-name="yrClosed"
                :data-vv-as="labels.yrClosed"
                v-validate="'between:0,' + maxYr"
                :disabled="prevYrClosed !== null && prevYrClosed !== 0"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-spacer class="mt-2"></v-spacer>
          <v-divider horizontal></v-divider>
          <v-layout>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout v-if="!newGLAcctNo">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ glacctNoForm.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <!-- <v-layout v-if="!newGLAcctNo">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.modifiedProgId}}</v-subheader>
              <div class="queryValue">{{glacctNoForm.modifiedProgId}}</div>
            </v-flex>
          </v-layout> -->
          <v-spacer class="mt-3"></v-spacer>
          <v-layout row wrap>
            <v-btn color="secondary" dark class=" mr-2" @click="doParentAcctDialog(true)" :loading="submitting" v-if="!newGLAcctNo">
              Add Parent Account
            </v-btn>
            <v-btn color="secondary" dark class=" mr-2" @click="doParentAcctDialog(false)" :loading="submitting" v-if="!newGLAcctNo">
              Remove Parent Account
            </v-btn>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Cancel</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              dark
              class=" mr-2"
              @click="srchChildDialog = true"
              v-if="!newGLAcctNo && glacctNoForm.postType === 'S'"
              :loading="submitting"
            >
              List Child Accounts
            </v-btn>
            <v-btn color="primary" dark class=" mr-2" @click="doSave(1)" :loading="submitting">
              Save & Continue
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
            <v-btn color="primary" dark class=" mr-2" @click="doSave(2)" :loading="submitting">
              Copy & Edit
              <v-icon right>mdi-pencil</v-icon>
            </v-btn>
            <v-btn color="primary" dark class=" mr-2" @click="doSave(0)" :loading="submitting">
              Save & Exit
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-dialog width="800px" v-model="helplist" persistent>
        <helplist
          :apiURI="helplistURI"
          :fieldList="helplistFields"
          :fieldKey1="helplistFieldKey1"
          :expand="helplistExpand"
          @select="doSelect($event)"
          @close="doClose"
          :key="helplist"
        ></helplist>
      </v-dialog>
      <v-dialog width="800px" v-model="parentAcctDialog" persistent>
        <parent-acct :link="link" :comp="comp" :parentAcct="parentAcct" :key="parentAcctDialog" @close="doClose($event)"></parent-acct>
      </v-dialog>
      <v-dialog width="800px" v-model="srchChildDialog" persistent>
        <srch-child @close="doClose" :key="srchChildDialog"></srch-child>
      </v-dialog>
    </v-card>
  </lazy-div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDate } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import Helplist from '@/components/parameters/helplist/helplist'
import ParentAcct from '../ParentAcct/ParentAcct'
import SrchChild from '../ParentAcct/SrchChild'
import { postType, acctType } from '@/const/acct/glAcct'
export default {
  data() {
    return {
      labels: {
        branch: 'GL Account No. Branch',
        glacctNo: 'GL Account No.',
        fund: 'GL Account No. Fund',
        acctNoSfx: 'GL Account No. Suffix',
        description: 'Description',
        acctType: 'Account Type',
        postType: 'Post Type',
        curr: 'Currency',
        revalue: 'Revalue Indicator',
        revalueAcctNo: 'Revalue GL Account No.',
        permGst: 'Permit GST',
        permDebtCashExp: 'Permit Debtor/ Cash Expense',
        yrClosed: 'Year Closed',
        parentAcct: 'Parent Account',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        modifiedProgId: 'Modified Program'
      },
      glacctNoForm: {
        branch: null,
        glacctNo: null,
        fund: null,
        acctNoSfx: null,
        description: null,
        acctType: null,
        postType: null,
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null,
        mixedCurr: null,
        curr: null,
        revalue: null,
        revalueAcctNo: null,
        revalueFund: null,
        revalueAcctNoSfx: null,
        yrClosed: 0,
        permGst: null,
        permDebtCashExp: null,
        createdProgId: null,
        modifiedProgId: null,
        brnDesc: null,
        fundDesc: null,
        acctNoSfxDesc: null,
        currDesc: null
      },
      helplistMenu: {},
      helplist: false,
      helplistURI: null,
      helplistFields: null,
      generalHelplist: false,
      helplistFieldKey1: null,
      helplistExpand: null,
      prevYrClosed: 0,
      submitting: false,
      comp: null,
      progid: 'glacctnoParam',
      dialog: false,
      parentAcctDialog: false,
      link: false,
      parentAcct: {
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null
      },
      srchChildDialog: false
    }
  },
  created() {
    if (!this.glacctNoId.branch && !this.glacctNoId.glacctNo) {
      const jsonData = JSON.parse(sessionStorage.getItem('glacctNo'))
      if (jsonData && jsonData.branch && jsonData.glacctNo) {
        this.$store.commit('GLACCTNO_COMMIT_KEY', jsonData)
      } else {
        this.$router.push({ name: 'glAcctNoList' })
      }
    }
  },
  mounted() {
    // this.loadHelplist()
  },
  methods: {
    async loadHelplist() {
      const apiURI = this.menu.glacctNoHelplist
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.helplistMenu = extractMenu(result.data._links)
            this.comp = data.data.comp
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    initForm() {
      this.glacctNoForm.branch = null
      this.glacctNoForm.glacctNo = null
      this.glacctNoForm.fund = ''
      this.glacctNoForm.acctNoSfx = ''
      this.glacctNoForm.description = null
      this.glacctNoForm.acctType = 'I'
      this.glacctNoForm.postType = 'P'
      this.glacctNoForm.parentAcctNo = null
      this.glacctNoForm.parentFund = null
      this.glacctNoForm.parentAcctNoSfx = null
      this.glacctNoForm.mixedCurr = null
      this.glacctNoForm.curr = null
      this.glacctNoForm.revalue = null
      this.glacctNoForm.revalueAcctNo = null
      this.glacctNoForm.revalueFund = null
      this.glacctNoForm.revalueAcctNoSfx = null
      this.glacctNoForm.yrClosed = 0
      this.glacctNoForm.permGst = null
      this.glacctNoForm.permDebtCashExp = null
      this.glacctNoForm.createdProgId = this.progid
      this.glacctNoForm.modifiedProgId = this.progid
      this.glacctNoForm.brnDesc = null
      this.glacctNoForm.fundDesc = null
      this.glacctNoForm.acctNoSfxDesc = null
      this.glacctNoForm.currDesc = null
      this.glacctNoForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.glacctNoForm.createdDate = new Date()
      this.glacctNoForm.modifiedBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.glacctNoForm.modifiedDate = new Date()
      this.glacctNoForm.curr = this.comp.currency
    },
    initGlacctNoId() {
      const commit = {
        branch: 'new',
        glacctNo: 'new',
        fund: null,
        acctNoSfx: null,
        curr: null,
        postType: null
      }
      sessionStorage.setItem('glacctNo', JSON.stringify(commit))
      this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
    },
    async doInit() {
      await this.loadHelplist()
      if (!this.newGLAcctNo) {
        await this.fetchData()
      } else {
        this.initForm()
      }
    },
    async fetchData() {
      const apiURI = this.menu.glacctNo
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glacctNoForm.branch = data.glacctNo.branch
            if (data.branch) {
              this.glacctNoForm.brnDesc = data.branch.brnDesc
            }
            this.glacctNoForm.glacctNo = data.glacctNo.glacctNo
            this.glacctNoForm.fund = data.glacctNo.fund
            if (data.fund) {
              this.glacctNoForm.fundDesc = data.fund.fundDesc
            }
            this.glacctNoForm.acctNoSfx = data.glacctNo.acctNoSfx
            if (data.acctNoSfx) {
              this.glacctNoForm.acctNoSfxDesc = data.acctNoSfx.description
            }
            this.glacctNoForm.description = data.glacctNo.description
            this.glacctNoForm.acctType = data.glacctNo.acctType
            this.glacctNoForm.postType = data.glacctNo.postType
            this.glacctNoForm.curr = data.glacctNo.curr
            if (data.curr) {
              this.glacctNoForm.currDesc = data.curr.currDesc
            }
            this.glacctNoForm.revalue = data.glacctNo.revalue
            this.glacctNoForm.revalueAcctNo = data.glacctNo.revalueAcctNo
            this.glacctNoForm.revalueFund = data.glacctNo.revalueFund
            this.glacctNoForm.revalueAcctNoSfx = data.glacctNo.revalueAcctNoSfx
            this.glacctNoForm.permGst = data.glacctNo.permGst
            this.glacctNoForm.permDebtCashExp = data.glacctNo.permDebtCashExp
            this.glacctNoForm.parentAcctNo = data.glacctNo.parentAcctNo
            this.glacctNoForm.parentFund = data.glacctNo.parentFund
            this.glacctNoForm.parentAcctNoSfx = data.glacctNo.parentAcctNoSfx
            this.glacctNoForm.yrClosed = data.glacctNo.yrClosed
            this.prevYrClosed = data.glacctNo.yrClosed
            this.glacctNoForm.createdBy = data.createdBy
            this.glacctNoForm.createdDate = data.createdDate
            this.glacctNoForm.modifiedBy = data.modifiedBy
            this.glacctNoForm.modifiedDate = data.modifiedDate
            this.glacctNoForm.createdProgId = data.glacctNo.createdProgId
            this.glacctNoForm.modifiedProgId = data.glacctNo.modifiedProgId
            this.glacctNoForm.mixedCurr = data.glacctNo.mixedCurr
            const commit = {
              branch: data.glacctNo.branch,
              glacctNo: data.glacctNo.glacctNo,
              fund: data.glacctNo.fund,
              acctNoSfx: data.glacctNo.acctNoSfx,
              curr: data.glacctNo.curr,
              postType: data.glacctNo.postType
            }
            this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doHelplist(field) {
      switch (field) {
        case 'branch': {
          this.helplistFieldKey1 = 'branch'
          this.helplistURI = this.helplistMenu.branchHelplist
          this.helplistFields = [
            { text: 'Branch', value: 'branch' },
            { text: 'Description', value: 'brnDesc' }
          ]
          this.helplist = true
          break
        }
        case 'fund': {
          this.helplistFieldKey1 = 'fund'
          this.helplistURI = this.helplistMenu.fundHelplist
          this.helplistFields = [
            { text: 'Fund', value: 'fund' },
            { text: 'Description', value: 'fundDesc' }
          ]
          this.helplist = true
          break
        }
        case 'acctNoSfx': {
          this.helplistFieldKey1 = 'acctNoSfx'
          this.helplistURI = this.helplistMenu.acctNoSfxHelplist
          this.helplistFields = [
            { text: 'Account No. Suffix', value: 'acctNoSfx' },
            { text: 'Description', value: 'description' }
          ]
          this.helplist = true
          break
        }
        case 'curr': {
          this.helplistFieldKey1 = 'curr'
          this.helplistURI = this.helplistMenu.currHelplist
          this.helplistFields = [
            { text: 'Currency', value: 'curr' },
            { text: 'Description', value: 'currDesc' }
          ]
          this.helplist = true
          break
        }
        case 'revalueAcct': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'revalueAcct'
          this.helplistURI = this.helplistMenu.revalueAcctHelplist
          this.helplistFields = [
            { text: 'Revalue Account No.', value: 'glacctNo' },
            { text: 'Revalue Fund', value: 'fund' },
            { text: 'Revalue Account No. Suffix', value: 'acctNoSfx' }
          ]
          this.helplistExpand = {
            branch: this.glacctNoForm.branch
          }
          this.helplist = true
          break
        }
        case 'parentAcct': {
          this.generalHelplist = true
          this.helplistFieldKey1 = 'parentAcct'
          this.helplistURI = this.helplistMenu.parentAcctHelplist
          this.helplistFields = [
            { text: 'Parent Account No.', value: 'glacctNo' },
            { text: 'Parent Fund', value: 'fund' },
            { text: 'Parent Account No. Suffix', value: 'acctNoSfx' }
          ]
          this.helplistExpand = {
            branch: this.glacctNoForm.branch,
            glacctNo: this.glacctNoForm.glacctNo,
            fund: this.glacctNoForm.fund,
            acctNoSfx: this.glacctNoForm.acctNoSfx,
            postType: this.glacctNoForm.postType,
            curr: this.glacctNoForm.curr
          }
          this.helplist = true
          break
        }
        default: {
          this.helplist = false
          this.generalHelplist = false
          break
        }
      }
    },
    doSelect(result) {
      this.resetMessages()
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'branch': {
            this.glacctNoForm.branch = result.data.branch
            this.glacctNoForm.brnDesc = result.data.brnDesc
            break
          }
          case 'fund': {
            this.glacctNoForm.fund = result.data.fund
            this.glacctNoForm.fundDesc = result.data.fundDesc
            break
          }
          case 'acctNoSfx': {
            this.glacctNoForm.acctNoSfx = result.data.acctNoSfx
            this.glacctNoForm.acctNoSfxDesc = result.data.description
            break
          }
          case 'curr': {
            this.glacctNoForm.curr = result.data.curr
            this.glacctNoForm.currDesc = result.data.currDesc
            break
          }
          case 'revalueAcct': {
            this.glacctNoForm.revalueAcctNo = result.data.glacctNo
            this.glacctNoForm.revalueFund = result.data.fund
            this.glacctNoForm.revalueAcctNoSfx = result.data.acctNoSfx
            break
          }
          case 'parentAcct': {
            this.glacctNoForm.parentAcctNo = result.data.glacctNo
            this.glacctNoForm.parentFund = result.data.fund
            this.glacctNoForm.parentAcctNoSfx = result.data.acctNoSfx
            break
          }
        }
      }
    },
    doValidate(field) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(this.fields[field].valid)
        }, 100)
      })
    },
    doCheck(field) {
      this.doValidate(field).then(async (result) => {
        if (result) {
          let desc = null
          let desc2 = null
          let apiURI = null
          let expand = {}
          switch (field) {
            case 'branch': {
              desc = 'brnDesc'
              apiURI = this.helplistMenu.branch
              expand.branch = this.glacctNoForm.branch
              break
            }
            case 'fund': {
              desc = 'fundDesc'
              apiURI = this.glacctNoForm.fund ? this.helplistMenu.fund : null
              expand.fund = this.glacctNoForm.fund
              break
            }
            case 'acctNoSfx': {
              desc = 'acctNoSfxDesc'
              desc2 = 'description'
              apiURI = this.glacctNoForm.acctNoSfx ? this.helplistMenu.acctNoSfx : null
              expand.acctNoSfx = this.glacctNoForm.acctNoSfx
              break
            }
            case 'curr': {
              desc = 'currDesc'
              apiURI = this.helplistMenu.curr
              expand.curr = this.glacctNoForm.curr
              break
            }
          }
          this.glacctNoForm[desc] = null
          if (!desc2) {
            desc2 = desc
          }
          if (apiURI) {
            try {
              const result = await this.$http.get(expandURI(apiURI, expand))
              const { data } = result.data
              if (data) {
                this.glacctNoForm[desc] = data[field][desc2]
              }
            } catch (err) {
              const { data } = err.response
              if (data) {
                this.notify(data)
                this.glacctNoForm[field] = null
              }
            }
          }
        }
      })
    },
    doClearParentAcct() {
      this.glacctNoForm.parentAcctNo = null
      this.glacctNoForm.parentFund = null
      this.glacctNoForm.parentAcctNoSfx = null
    },
    doClose(reload) {
      this.dialog = false
      this.helplist = false
      this.parentAcctDialog = false
      this.srchChildDialog = false
      if (reload) {
        this.fetchData()
      }
    },
    /**
     * 0: Save and Exit
     * 1: Save and Continue
     * 2: Copy and Edit
     */
    async doSave(options) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSaveMain()
            .then((result) => {
              if (result) {
                this.notify(result)
                switch (options) {
                  case 0: {
                    this.$router.push({ name: 'glAcctNoList' })
                    break
                  }
                  case 1: {
                    this.initForm()
                    this.initGlacctNoId()
                    break
                  }
                  case 2: {
                    this.initGlacctNoId()
                    this.glacctNoForm.yrClosed = 0
                    this.glacctNoForm.createdProgId = this.progid
                    this.glacctNoForm.modifiedProgId = this.progid
                    this.glacctNoForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
                    this.glacctNoForm.createdDate = new Date()
                    this.glacctNoForm.modifiedBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
                    this.glacctNoForm.modifiedDate = new Date()
                    break
                  }
                }
              }
            })
            .catch((err) => {
              if (err.response) {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              }
            })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    customValidation() {
      if (this.glacctNoForm.yrClosed != null && this.glacctNoForm.yrClosed !== 0) {
        if (this.glacctNoForm.yrClosed === this.comp.currAcctYr) {
          this.$toast.error('Cannot be same as Current Accounting Year.')
          return false
        }
      }
      return true
    },
    async doSaveMain() {
      this.resetMessages()
      return new Promise((resolve, reject) => {
        if (!this.glacctNoForm.revalue) {
          this.glacctNoForm.revalueAcctNo = null
          this.glacctNoForm.revalueFund = null
          this.glacctNoForm.revalueAcctNoSfx = null
        }
        this.submitting = true
        this.glacctNoForm.modifiedProgId = this.progid
        if (this.customValidation()) {
          const config = {
            method: this.newGLAcctNo ? 'post' : 'put',
            url: this.newGLAcctNo ? this.menu.createGlacctNo : this.menu.updateGlacctNo,
            data: this.glacctNoForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                const commit = {
                  branch: this.glacctNoForm.branch,
                  glacctNo: this.glacctNoForm.glacctNo,
                  fund: this.glacctNoForm.fund,
                  acctNoSfx: this.glacctNoForm.acctNoSfx,
                  postType: this.glacctNoForm.postType,
                  curr: this.glacctNoForm.curr
                }
                this.$store.commit('GLACCTNO_COMMIT_KEY', commit)
                sessionStorage.setItem('glacctNo', JSON.stringify(commit))
                this.submitting = false
                resolve(data)
              })
              .catch((err) => {
                this.submitting = false
                reject(err)
              })
          } else {
            this.submitting = false
            reject(Error('API not existed'))
          }
        } else {
          this.submitting = false
          reject(Error('Validation failed'))
        }
      })
    },
    /**
     * true: link
     * false: unlink
     */
    async doParentAcctDialog(link) {
      const validate = await this.$validator.validateAll()
      if (validate) {
        try {
          await this.doSaveMain()
        } catch (err) {
          if (err.response) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
          return
        }
      } else {
        this.promptFieldCheck()
        return
      }
      if (this.glacctNoForm.yrClosed !== null && this.glacctNoForm.yrClosed !== 0) {
        this.$toast.error('Cannot update this record because Year Closed is not blank (10343)')
        return
      }
      if (link) {
        if (this.glacctNoForm.parentAcctNo || this.glacctNoForm.parentFund || this.glacctNoForm.parentAcctNoSfx) {
          this.$toast.error('Already linked to a Parent Account (30027)')
          return
        }
      } else {
        if (!this.glacctNoForm.parentAcctNo && !this.glacctNoForm.parentFund && !this.glacctNoForm.parentAcctNoSfx) {
          this.$toast.error('This GL Account is not linked to a Parent Account (30028)')
          return
        } else {
          try {
            this.submitting = true
            const apiURI = this.menu.checkGLLedger
            const expand = this.glacctNoId
            await this.$http.get(expandURI(apiURI, expand))
            this.submitting = false
          } catch (err) {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
            return
          }
          this.parentAcct.parentAcctNo = this.glacctNoForm.parentAcctNo
          this.parentAcct.parentFund = this.glacctNoForm.parentFund
          this.parentAcct.parentAcctNoSfx = this.glacctNoForm.parentAcctNoSfx
        }
      }
      this.dialog = true
      this.parentAcctDialog = true
      this.link = link
    },
    doCancel() {
      this.$router.push({ name: 'glAcctNoList' })
    }
  },
  beforeRouteLeave(to, from, next) {
    // save before going to other two tabs
    if (to.name === 'glPostAcct' || to.name === 'glBudget') {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doSaveMain()
            .then((result) => {
              if (result) {
                this.notify(result)
                next()
              } else {
                next(false)
              }
            })
            .catch((err) => {
              if (err.response) {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              }
              next(false)
            })
        } else {
          this.promptFieldCheck()
          next(false)
        }
      })
    } else {
      sessionStorage.removeItem('glacctNo')
      next()
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    postTypeList() {
      let result = []
      Object.keys(postType).forEach((key) => {
        const status = postType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach((key) => {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maxYr() {
      return new Date().getFullYear()
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    },
    newGLAcctNo() {
      return this.glacctNoId.branch === 'new' && this.glacctNoId.glacctNo === 'new'
    },
    revalueAE() {
      if (this.glacctNoForm.curr) {
        return !(this.glacctNoForm.curr === this.comp.currency)
      } else {
        return false
      }
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  components: {
    Helplist,
    ParentAcct,
    SrchChild
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
